module.exports = __webpack_public_path__ + "static/media/settings.ae4802db.png";